import { useEffect, useState } from 'react';
import { Navigate, Route, Routes, useLocation, useNavigate } from 'react-router-dom';
import "remixicon/fonts/remixicon.css";
import './App.css';
import Navbar from './Components/Sidebar/MentorSidebar';
import AdminNavbar from './Components/Sidebar/AdminSidebar';
import SuperAdminSidebar from './Components/Sidebar/SuperAdminSidebar';
import Dashboard from './Pages/Dashboard/Dashboard';
import AdminDashboard from './Pages/Dashboard/AdminDashboard';
import SuperAdminDashboard from './Pages/Dashboard/SuperAdminDashboard';
import Login from './Pages/Login/Login';
import Courses from './Pages/Courses/Courses';
import Profile from './Pages/Navbar';
import NewCourse from './Pages/AddLesson/index';
import Loader from './Pages/Loader';
import Preview from './Pages/Preview';
import NotificationPage from './Pages/NotificationPage';
import CourseDetail from './Pages/CourseDetail';
import AddLesson from './Pages/AddLesson';
import EditLesson from './Pages/EditLesson/EditLesson';
import LessonPreview from './Components/LessonPreview/LessonPreview';
import ConfirmLesson from './Components/ConfirmLesson/ConfirmLesson';
import Details from './Components/ConfirmDetails/Details';
import MyCourses from './Pages/MyCourse/MyCourse';
import MentorConfirmLesson from './Components/ConfirmLesson/MentorConfirmLesson';
import NewEmployeeForm from './Pages/NewEmployee';
import { ToastContainer } from 'react-toastify';
import UpdateCourse from './Pages/Courses/UpdateCourse';
import UpdateLessons from './Pages/Courses/UpdateLessons';
import Certificate from './Pages/Certificate/Certificate';
import SocialNetworks from './Pages/SocialNetworks/SocialNetwork'
import AboutUs from './Pages/AboutUs/AboutUs';
import SortableChapter from './Pages/Courses/SortableChapter'
import Students from './Components/Students/Students';
import ExamResult from './Components/Students/ExamResult';
import RequestReview from './Components/RequestReview';
import StudentInfoOfCourse from './Pages/Dashboard/StudentInfoOfCourse';
import Chatbot from './Components/Chatbot/Index'
import CertificateHolders from './Pages/Certificate/CertificateHolders';
import CertificateFile from './Pages/Certificate/CertificateFile';
import PromoList from './Pages/PromoCode/PromoCode';
import CoursesTable from './Pages/Dashboard/Students';
import SalesReport from './Pages/Dashboard/SalesReport';
import StudentActivity from './Pages/LearningActivity/StudentActivity';
import CourseActivity from './Pages/LearningActivity/CourseActivity';
import GeneratingHistory from './Components/GenerateHistory/GenerateHistory';
import VideoPagesEditor from './Pages/Loader/WatchVideo';
import VideoPagesReview from './Pages/Loader/WatchVideo';
import AppContent from './Components/layout/AppContent/AppContent';
import AutoContinueRunner from './Components/GenerateHistory/autoContinue/AutoContinueRunner';
import CabinetRoute from './roles/components/CabinetRoute';
import CabinetsIndex from './roles/components/CabinetsIndex';
import CabinetSidebar from './roles/components/CabinetSidebar';
import { cabinetViewFor, homePathFor } from './roles/access';
import { ROLES, isNewRole } from './roles/config';
import { useDemoRole } from './roles/useDemoRole';
import { Spinner } from './Components/ui';

function App() {
  const location = useLocation();
  const navigate = useNavigate();

  const [role, setRole] = useState(localStorage.getItem("role") || "");
  const [token, setToken] = useState(localStorage.getItem("admin_token") || "");

  useEffect(() => {
    const updateAuthState = () => {
      setRole(localStorage.getItem("role") || "");
      setToken(localStorage.getItem("admin_token") || "");
    };

    window.addEventListener("storage", updateAuthState);
    return () => {
      window.removeEventListener("storage", updateAuthState);
    };
  }, []);

  useEffect(() => {
    const isCertificatePage = location.pathname.startsWith("/certificate/");

    if (!token && !isCertificatePage) {
      navigate("/login");
    } else if (token && location.pathname === "/login") {
      navigate("/");
    }
  }, [token, role, location.pathname, navigate]);

  // Yangi layout faqat sidebar/header ko'rsatiladigan holatda (shart avvalgidek).
  // Aks holda (login, tizimga kirmagan holatdagi sertifikat sahifasi) eski "App"/"right" o'rami saqlanadi.
  const withLayout = Boolean(token) && location.pathname !== "/login";

  // Vaqtinchalik demo: test akkauntlar (backend roli "admin") telefon bo'yicha rol kabinetiga tushadi.
  // uiRole — sidebar, route'lar va kabinet uchun rol. Demo bo'lmasa backend roli bilan bir xil
  // (super_admin va mentor uchun doim). Login'dan keyingi tekshiruv paytida bo'sh — hech qaysi sahifa ochilmaydi.
  const demo = useDemoRole(token, role);
  const uiRole = demo.pending ? "" : demo.demoRole || role;

  // Rollar kabinetlari: yangi rollar — o'z kabineti; super_admin — /cabinet/... da ko'rish rejimi.
  // Mavjud rollar (admin, mentor, super_admin boshqa sahifalarda) uchun null — avvalgidek.
  const cabinetView = withLayout ? cabinetViewFor(uiRole, location.pathname) : null;
  const cabinetRoleLabel = cabinetView
    ? `${ROLES[cabinetView.role].name}${cabinetView.preview ? " · ko'rish" : ""}`
    : undefined;

  return (
    <div className={withLayout ? "ui-app" : "App"}>
      {token && location.pathname !== "/login" && (
        <>
          {uiRole === "mentor" && <Navbar />}
          {uiRole === "admin" && <AdminNavbar />}
          {uiRole === "super_admin" && !cabinetView && <SuperAdminSidebar />}
          {cabinetView && <CabinetSidebar role={cabinetView.role} />}
        </>
      )}
      <div className={withLayout ? "ui-app__main" : "right"}>
        {token && location.pathname !== "/login" && !demo.pending && <Profile role={role} setRole={setRole} roleLabel={cabinetRoleLabel} />}
        <AppContent enabled={withLayout} bare={location.pathname.startsWith("/certificate/")}>
        {demo.pending && (
          <div className="ui-cab-pending">
            <Spinner size="lg" label="Kabinet aniqlanmoqda" />
          </div>
        )}
        <Routes>
          {!token ? (
            <>
              <Route path='/login' element={<Login setToken={setToken} setRole={setRole} />} />
              <Route path="/certificate/:id/:courseId" element={<CertificateFile />} />
            </>
          ) : (
            <>
              {/* Rollar kabinetlari (kirish huquqi CabinetRoute/CabinetsIndex ichida tekshiriladi) */}
              <Route path="/cabinets" element={<CabinetsIndex userRole={uiRole} />} />
              <Route path="/cabinet/:role" element={<CabinetRoute userRole={uiRole} />} />
              <Route path="/cabinet/:role/:page" element={<CabinetRoute userRole={uiRole} />} />
              {isNewRole(uiRole) && <Route path="*" element={<Navigate to={homePathFor(uiRole)} replace />} />}

              {uiRole === "mentor" && (
                <>
                  <Route path='/' element={<AdminDashboard />} />
                  <Route path='/courses' element={<MyCourses />} />
                  <Route path='/:course' element={<CourseDetail />} />
                  <Route path='/course-details' element={<Details />} />
                  <Route path='/new-lesson' element={<NewCourse />} />
                  <Route path='/status' element={<Loader />} />
                  <Route path='/preview' element={<Preview />} />
                  <Route path='/notifications/:type' element={<NotificationPage />} />
                  <Route path='/add-lesson' element={<AddLesson />} />
                  <Route path='/edit-lesson' element={<EditLesson />} />
                  <Route path='/lesson-preview' element={<LessonPreview />} />
                  <Route path='/lesson-confirmation' element={<MentorConfirmLesson />} />
                  <Route path='/course-details/chatbot' element={<Chatbot />} />
                  <Route path="/certificate/:id/:courseId" element={<CertificateFile />} />
                </>
              )}

              {uiRole === "admin" && (
                <>
                  <Route path="/" element={<AdminDashboard />} />
                  <Route path='/courses' element={<Courses />} />
                  <Route path='/:course' element={<CourseDetail />} />
                  <Route path='/new-lesson' element={<NewCourse />} />
                  <Route path='/status' element={<Loader />} />
                  <Route path='/watch-video' element={<VideoPagesReview />} />
                  <Route path='/history' element={<GeneratingHistory />} />
                  <Route path='/preview' element={<Preview />} />
                  <Route path='/notifications/:type' element={<NotificationPage />} />
                  <Route path='/new-employee' element={<NewEmployeeForm />} />
                  {/* <Route path='/add-lesson' element={<AddLesson />} /> */}
                  {/* <Route path='/edit-lesson' element={<EditLesson />} /> */}
                  <Route path='/lesson-preview' element={<LessonPreview />} />
                  <Route path='/lesson-preview/confirm' element={<ConfirmLesson />} />
                  <Route path='/edit-course' element={<UpdateCourse />} />
                  <Route path='/courses/update-lesson' element={<UpdateLessons />} />
                  <Route path='/certificate' element={<Certificate />} />
                  <Route path='/social-media' element={<SocialNetworks />} />
                  <Route path='/about' element={<AboutUs />} />
                  <Route path='/partners' element={<AboutUs />} />
                  {/* <Route path="/Students" element={<Students />} /> */}
                  <Route path="/exam-result" element={<ExamResult />} />
                  <Route path="/student-info" element={<RequestReview />} />
                  <Route path="/course/students" element={<StudentInfoOfCourse />} />
                  <Route path="/certificate-holders" element={<CertificateHolders />} />
                  <Route path="/certificate/:id/:courseId" element={<CertificateFile />} />
                  <Route path="/promo-code" element={<PromoList />} />
                  <Route path="/students" element={<CoursesTable />} />
                  <Route path="/learning-activity" element={<StudentActivity />} />
                  <Route path="/learning-analytics" element={<CourseActivity />} />
                  <Route path="/sales" element={<SalesReport />} />

                </>
              )}

              {uiRole === "super_admin" && (
                <>
                  <Route path="/" element={<SuperAdminDashboard />} />
                  <Route path='/courses' element={<Courses />} />
                  <Route path='/status' element={<Loader />} />
                  <Route path='/watch-video' element={<VideoPagesEditor />} />
                  <Route path='/history' element={<GeneratingHistory />} />
                  <Route path='/preview' element={<Preview />} />
                  <Route path='/new-lesson' element={<NewCourse />} />
                  <Route path='/notifications/:type' element={<NotificationPage />} />
                  <Route path='/new-employee' element={<NewEmployeeForm />} />
                  <Route path='/edit-course' element={<UpdateCourse />} />
                  <Route path='/courses/update-lesson' element={<UpdateLessons />} />
                  <Route path='/certificate' element={<Certificate />} />
                  <Route path='/social-media' element={<SocialNetworks />} />
                  <Route path='/about' element={<AboutUs />} />
                  <Route path='/partners' element={<AboutUs />} />
                  {/* <Route path="/Students" element={<Students />} /> */}
                  <Route path="/exam-result" element={<ExamResult />} />
                  <Route path="/student-info" element={<RequestReview />} />
                  <Route path="/course/students" element={<StudentInfoOfCourse />} />
                  <Route path="/certificate-holders" element={<CertificateHolders />} />
                  <Route path="/certificate/:id/:courseId" element={<CertificateFile />} />
                  <Route path="/promo-code" element={<PromoList />} />
                  <Route path="/students" element={<CoursesTable />} />
                  <Route path="/learning-activity" element={<StudentActivity />} />
                  <Route path="/learning-analytics" element={<CourseActivity />} />
                  <Route path="/sales" element={<SalesReport />} />
                </>
              )}
            </>
          )}

        </Routes>
        </AppContent>

        <ToastContainer />
        {token && (uiRole === "admin" || uiRole === "super_admin") && <AutoContinueRunner />}
      </div>
    </div>
  );
}

export default App;
